import { createContext } from 'react'

export const UserContext = createContext()
export const WorkContext = createContext([])
